import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '../translations';

const LanguageContext = createContext();

const AVAILABLE_LANGUAGES = [
  { code: 'en-US', label: 'English', flag: '🇨🇦' },
  { code: 'fr-CA', label: 'Français', flag: '🇨🇦' }
];

const STORAGE_KEY = 'blind_app_language';

export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved || 'en-US';
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, currentLanguage);
  }, [currentLanguage]);

  const t = (key) => {
    const keys = key?.split('.');
    let value = translations?.[currentLanguage];
    
    for (const k of keys) {
      value = value?.[k];
      if (value === undefined) {
        return key;
      }
    }
    
    return value || key;
  };

  const changeLanguage = (languageCode) => {
    if (AVAILABLE_LANGUAGES?.some(lang => lang?.code === languageCode)) {
      setCurrentLanguage(languageCode);
    }
  };

  let value = {
    currentLanguage,
    changeLanguage,
    t,
    availableLanguages: AVAILABLE_LANGUAGES
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

export default LanguageContext;